import styled from "styled-components";

export const ModalBody = styled.form`
	display: flex;
	flex-direction: column;
	gap: 16px;
`;

export const Title = styled.h1`
	font-size: 24px;
	font-weight: 700;
	line-height: 30px;
	color: #31475a;
	text-align: center;
`;

export const Description = styled.p`
	font-size: 16px;
	color: #31475a;
	text-align: center;
`;
